import { Molecule, wrap } from 'AppReact';
import styled from 'styled-components';
import { Mt2, FlexCenterWrapper, Mr2, ElementWithPopupWrapper, Mt1, TooltipPopup } from 'wrappers';
import { SecondaryTextSm, SecondaryTextBaseBold, CustomText, Empty, WhiteTextXs } from 'atoms';
import { textEllipsis } from 'utils/ellipsis';
import { prioritySettings, getIconByName } from 'utils';

const template = styled.div`
`;

export default Molecule({
  template,
  atoms: [
    {
      wrapper: FlexCenterWrapper,
      name: 'TopRow',
      atoms: [
        {
          component: wrap(CustomText, Mr2),
          name: 'CallBack',
          renderIf: ({ order }) => order?.is_callback && order.status !== 'completed',
          displayValue: ({ }) => 'CALLBACK',
          displayState: ({ }) => ({ color: '#E6B300', fontSize: '12px', fontWeight: 600, letterSpacing: '0.72px' })
        },
        {
          component: wrap(wrap(CustomText, Mr2), Mt1),
          name: 'Level',
          renderIf: ({ order }) => !order.is_default_priority,
          displayValue: ({ order }) => order.priority_name?.toUpperCase() ?? '',
          displayState: ({ order }) => {
            return { fontSize: '12px', color: prioritySettings[order?.priority_color]?.textColor, fontWeight: 600, letterSpacing: '0.72px' }
          }
        },
        {
          wrapper: ElementWithPopupWrapper,
          name: 'NoAccessToolTip',
          atoms: [
            {
              component: wrap(Empty, Mr2),
              name: 'NoAccess',
              renderIf: ({ order }) => order.status !== 'completed' && order.mark_no_access,
              displayValue: ({ }) => getIconByName({ name: 'Lock', width: 15, height: 15 }),
            },
            {
              wrapper: TooltipPopup,
              name: 'PopupWrapper',
              displayState: ({ order }) => ({ position: 'right', maxWidth: '600px', width: 'unset', minWidth: '400px', maxHeight: '85px', lineClamp: 3, topTransform: '15px' }),
              atoms: [
                {
                  component: WhiteTextXs,
                  name: 'Popup',
                  displayValue: ({ order }) => order?.last_no_access_reason ? `Unable To Access: ${textEllipsis(order?.last_no_access_reason ?? '', 170)}` : ''
                }
              ]
            }
          ]
        },
        {
          wrapper: ElementWithPopupWrapper,
          name: 'WaitingOnPartsTooltip',
          atoms: [
            {
              component: wrap(Empty, Mr2),
              name: 'WaitingOnParts',
              renderIf: ({ order }) => order.status !== 'completed' && order.waiting_on_parts,
              displayValue: ({ }) => getIconByName({ name: 'SingleHammer', width: 15, height: 15 }),
            },
            {
              wrapper: TooltipPopup,
              name: 'PopupWrapper',
              displayState: ({ order }) => ({ position: 'right', maxWidth: '600px', width: 'unset', minWidth: '400px', maxHeight: '85px', lineClamp: 3, topTransform: '15px' }),
              atoms: [
                {
                  component: WhiteTextXs,
                  name: 'Popup',
                  displayValue: ({ order }) => order?.waiting_on_parts_reason ? `Waiting on Parts: ${textEllipsis(order?.waiting_on_parts_reason ?? '', 170)}` : ''
                }
              ]
            }
          ]
        },
        {
          component: SecondaryTextBaseBold,
          name: 'Category',
          displayValue: ({ order }) => order.is_callback && order.is_high_priority ? textEllipsis(order?.category_name ?? '', 13) : order?.category_name ?? '',
        },
      ]
    },
    {
      wrapper: ElementWithPopupWrapper,
      name: 'CategoryParentToolTip',
      atoms: [
        {
          component: wrap(SecondaryTextSm, Mt2),
          name: 'CategoryParent',
          displayValue: ({ order }) => textEllipsis(order?.creation_note ?? '', 52),
        },
        {
          wrapper: TooltipPopup,
          name: 'CategoryPopupWrapper',
          renderIf: ({ order }) => order?.creation_note && order.creation_note.length > 52,
          displayState: ({ }) => ({ position: 'top', maxWidth: '600px', width: 'unset', minWidth: '400px', maxHeight: '85px', topTransform: '-40px', }),
          atoms: [
            {
              component: WhiteTextXs,
              name: 'Popup',
              displayValue: ({ order }) => order?.creation_note ?? '',
            }
          ]
        }
      ]
    }
  ],
});
